<template>
  <div>
    <div class="p-3 bg-white rounded-xl shadow-lg mb-5 mt-4 mx-0">
      <div
        class="grid grid-cols-2 cursor-pointer"
        @click="showFilters = !showFilters"
      >
        <div class="flex items-center gap-4">
          <a-icon type="filter" class="text-lg ml-2"></a-icon>
          <h2 class="text-left text-lg text-gray-600">
            <b>Filtros de búsqueda</b>
          </h2>
        </div>
        <span
          class="h-5 w-5 m-2 flex justify-center items-center transition justify-self-end"
          :class="{ 'transform rotate-180': showFilters }"
        >
          <a-icon type="caret-down" class="text-xl my-auto" />
        </span>
      </div>
      <a-divider v-if="showFilters" class="mt-2 mb-2"></a-divider>
      <div
        class="flex gap-5 flex-wrap relative w-full border-box"
        v-show="showFilters"
      >
        <form id="filterSupportForm" @submit.prevent="submitForm">
          <div
            class="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 relative"
          >
            <!-- Codigo de queja -->
            <BaseInput
              type="text"
              label="Código de queja"
              placeholder="Ej: 26598965472981"
              v-model="form.codigo_queja"
            />

            <template v-if="isStandard || isAll">
              <!--Entidad -->
              <BaseSelect
                ref="entidad"
                id="entidad"
                label="Entidad"
                :selectOptions="formOptions.optionsCompanies"
                v-model="form.entidad"
                :value="form.entidad"
              />
              <!--Motivos -->
              <BaseSelect
                ref="motivos"
                id="motivos"
                label="Motivos"
                :selectOptions="formOptions.optionsReasons"
                v-model="form.motivo"
                :value="form.motivo"
              />
              <!--Estado -->
              <BaseSelect
                ref="estado"
                id="estado"
                label="Estado"
                :selectOptions="formOptions.optionsStates"
                v-model="form.estado"
                :value="form.estado"
              />
            </template>

            <template v-if="isAgiliza">
              <!--Entidad Agiliza -->
              <BaseSelect
                ref="entidad_agiliza"
                id="entidad_agiliza"
                label="Entidad Agiliza"
                :selectOptions="customCompaniesAgiliza"
                v-model="form.entidad_agiliza"
                :value="form.entidad_agiliza"
              />
              <!--Motivos Agiliza -->
              <BaseSelect
                ref="motivos_agiliza"
                id="motivos_agiliza"
                label="Motivo Agiliza"
                :selectOptions="formOptions.optionsReasonsAgiliza"
                v-model="form.motivo_agiliza"
                :value="form.motivo_agiliza"
              />
            </template>
            <template v-if="isAll || isAgiliza">
              <template v-if="isAgiliza && activeKey === '1'">
                <!--Estado Agiliza -->
                <BaseSelect
                  ref="estado_agiliza"
                  id="estado_agiliza"
                  label="Estado Agiliza"
                  :selectOptions="formOptions.optionsStatesAgilizaCf"
                  v-model="form.estado_agiliza"
                  :value="form.estado_agiliza"
                />
              </template>
              <!--Estado de la sesión - multiple -->

              <template
                v-if="isAgiliza && (activeKey === '2' || activeKey === '3')"
              >
                <BaseMultiSelect
                  :valuesSelected="void_array"
                  title="Estado de la sesión"
                  :data="customStatesSessions"
                  label="name"
                  @notify-objects="setMultiSelect($event)"
                />
                <!-- Fecha de sesión. -->
                <BaseRangeDate
                  ref="fecha_de_sesion"
                  label="Fecha de sesión"
                  :value="
                    form.session_start && form.session_end
                      ? [form.session_start, form.session_end]
                      : null
                  "
                  @notify-dates="setRangeDateSession($event)"
                />
              </template>
            </template>
          </div>

          <div class="w-full flex justify-end self-end gap-4 mt-5 mb-3">
            <a-button
              class="w-1/2 gap-2 sm:mt-auto mt-3 lg:w-1/6"
              type="primary"
              ghost
              shape="round"
              @click="clearFilters"
            >
              Limpiar
            </a-button>

            <!-- :disabled="disableButton && disabled" -->
            <!-- :loading="(searching = loading)"  -->
            <a-button
              :disabled="searching ? true : false"
              type="primary"
              shape="round"
              @click="submitForm"
              class="w-1/2 gap-2 sm:mt-auto mt-3 lg:w-1/6"
            >
              <a-icon type="search" v-if="!searching"></a-icon>
              {{ searching ? "BUSCANDO..." : "BUSCAR" }}
            </a-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from "@/core/utils/constants";

export default {
  props: {
    activeKey: {
      type: String,
      default: "1",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    searching: {
      type: Boolean,
      default: false,
    },
    complaintType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      form: {
        codigo_queja: "",
        entidad: "",
        entidad_agiliza: "",
        motivo: "",
        motivo_agiliza: "",
        estado: "",
        estado_agiliza: "",
        session_state_agiliza: [],
        session_start: "",
        session_end: "",
      },
      isAll: false,
      isStandard: false,
      isAgiliza: false,
      showFilters: false,
      void_array: [],
    };
  },
  created() {
    switch (this.complaintType) {
      case "todas":
        this.isAll = true;
        this.isStandard = false;
        this.isAgiliza = false;
        break;
      case "estandar":
        this.isStandard = true;
        this.isAll = false;
        this.isAgiliza = false;
        break;
      case "agiliza":
        this.isAgiliza = true;
        this.isAll = false;
        this.isStandard = false;
        break;

      default:
        break;
    }
    this.initializeForm();
  },
  async mounted() {
    const pagination = {};
    this.$emit("getFilterForm", this.form, pagination);
  },
  methods: {
    async submitForm() {
      const formToSubmit = {
        ...this.form,
        agiliza_estado_sesion: Array.isArray(this.form.session_state_agiliza)
          ? this.form.session_state_agiliza.join(",")
          : this.form.session_state_agiliza,
      };

      const pagination = {
        page: DEFAULT_PAGE,
        pageSize: DEFAULT_PAGE_SIZE,
      };

      this.$emit("getFilterForm", formToSubmit, pagination);
    },
    async clearFilters() {
      this.initializeForm();

      const pagination = {
        page: DEFAULT_PAGE,
        pageSize: DEFAULT_PAGE_SIZE,
      };

      this.$emit("getFilterForm", this.form, pagination);
    },
    initializeForm() {
      this.void_array = [];
      this.form = {
        codigo_queja: "",
        entidad: "",
        entidad_agiliza: "",
        motivo: "",
        motivo_agiliza: "",
        estado: "",
        estado_agiliza: "",
        session_state_agiliza: [],
        session_start: "",
        session_end: "",
      };
    },
    setRangeDateSession(eventValue) {
      this.form.session_start = eventValue ? eventValue[0] : "";
      this.form.session_end = eventValue ? eventValue[1] : "";
    },
    setMultiSelect(ev) {
      this.form.session_state_agiliza = ev.map((item) => item.id);
    },
  },
  computed: {
    formOptions: function () {
      return this.$store.state.form;
    },
    customCompaniesAgiliza: function () {
      return this.$store.state.form?.optionsCompanies?.filter(
        (item) => item.is_agiliza === true,
      );
    },
    customStatesSessions: function () {
      return this.$store.state.form?.optionsStatesSessionsCf?.filter(
        (entity) => entity.id !== 0,
      );
    },
  },
};
</script>

<style>
#filterSupportForm {
  width: 100%;
}
</style>
